export const isEnvVariableTrue = (value) => value === 'true'
